import { render } from "./DashboardValuePlayers.vue?vue&type=template&id=a54b2266&scoped=true"
import script from "./DashboardValuePlayers.vue?vue&type=script&lang=js"
export * from "./DashboardValuePlayers.vue?vue&type=script&lang=js"

import "./DashboardValuePlayers.vue?vue&type=style&index=0&id=a54b2266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54b2266"]])

export default __exports__